import {ReportNavigatorService} from '../services/report-navigator.service';
import { Component, OnInit, Input } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
import { Scale } from 'app/shared/models/scale';
import { ScaleRange } from 'app/shared/models/scale-range';
import { CopyClipboardService } from 'app/shared/services/copy-clipboard.service';

@Component({
  selector: 'app-scale-results-table-summary',
  templateUrl: './scale-results-table-summary.component.html'
})
export class ScaleResultsTableSummaryComponent implements OnInit {
  @Input() scaleResults:ScaleResult[];
  @Input() severityLabels:string[];
  @Input() rangeLabelMapping:any;
  @Input() highlightScaleResults:ScaleResult[];
  @Input() showViewLink:boolean;
  public tableSummaryContent:string;

  constructor( private navigator:ReportNavigatorService, private copyClipboardService:CopyClipboardService) { 
    this.showViewLink = true;
  }

  ngOnInit() {
    
  }

  public copyTable() {
    let copyTable = [];
    copyTable.push(["Scale", "Description", "Raw Score / Total","Severity"]);
    if (this.scaleResults.length) {
      this.scaleResults.forEach(sr => {
        let row = [];
        row.push(sr.scale.name ? '"' + sr.scale.name + '"' : '');
        row.push(sr.scale.descriptionTherapist ? '"' + sr.scale.descriptionTherapist + '"' : '');
        row.push('"' + sr.score + " / " + sr.scale.getMaxScore() + '"');
        row.push('"' + this.getLabelNameForRange(sr) + '"');
        copyTable.push(row);
      });
    }
    this.copyClipboardService.copyTableToText(copyTable);
  }

  public getMaxName(obj:any) {
    if (typeof obj.name !== 'string') {
      return '';       
    }

    let strLen = Math.min(obj.name.length, 255);
    return obj.name.substring(0, strLen);
  }

  public getScaleResultClassNames(scaleResult:ScaleResult) {
    if (this.highlightScaleResults && this.highlightScaleResults.length)
    {
      if (this.highlightScaleResults.find(hs => hs.scale.id == scaleResult.scale.id)) {
        return ["primary-color text-light highlight-result"];
      }
    }
    return [];
  }

  public goToScaleResult(scaleResult:ScaleResult) {
    if (this.navigator.hasNavigationItem(scaleResult.scale.id)) {
      this.navigator.navigate(scaleResult.scale.id);
    }
  }

  public getTotalPossibleForResult(scaleResult:ScaleResult) {
    return scaleResult.scale.getMaxScore();
  }

  public getLabelNameForRange(scaleResult:ScaleResult) {
    let name = scaleResult.getRangeDisplayName();
    if (this.rangeLabelMapping &&
      this.rangeLabelMapping[scaleResult.scale.id]) {
      let scaleMap = this.rangeLabelMapping[scaleResult.scale.id];
      if (scaleMap[scaleResult.range.id]) {
        name = scaleMap[scaleResult.range.id];
      }
    }
    return name;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/scale-results-table-summary/scale-results-table-summary.component.ts